export default "__VITE_ASSET__5a8690cd__"